import { render, staticRenderFns } from "./Right_sideMenu.vue?vue&type=template&id=773f27c6"
import script from "./Right_sideMenu.vue?vue&type=script&lang=js"
export * from "./Right_sideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports